import { CreditCard } from "lucide-react";

/**
 * Logo de la marca de la tarjeta. Los SVG van inline (y no como imágenes remotas)
 * para no depender de un CDN en una pantalla de cobro.
 *
 * La marca la reporta Culqi en `iin.card_brand` sin garantizar el formato, así que
 * se normaliza antes de comparar y cualquier valor desconocido cae al icono genérico.
 */

const BRAND_LABELS: Record<string, string> = {
  visa: "Visa",
  mastercard: "Mastercard",
  amex: "American Express",
  diners: "Diners Club",
};

function normalize(brand: string | null): string | null {
  if (!brand) return null;
  const clean = brand.toLowerCase().replace(/[^a-z]/g, "");
  if (clean.includes("visa")) return "visa";
  if (clean.includes("master")) return "mastercard";
  if (clean.includes("amex") || clean.includes("american")) return "amex";
  if (clean.includes("diners")) return "diners";
  return null;
}

export function CardBrandIcon({ brand }: { brand: string | null }) {
  const key = normalize(brand);

  if (!key) {
    return (
      <CreditCard className="size-4 text-slate-400" aria-label="Tarjeta" />
    );
  }

  return (
    <svg
      viewBox="0 0 48 32"
      className="h-5 w-8 shrink-0"
      role="img"
      aria-label={BRAND_LABELS[key]}
    >
      <rect
        width="48"
        height="32"
        rx="4"
        className="fill-white stroke-slate-200 dark:fill-slate-800 dark:stroke-slate-700"
        strokeWidth="1"
      />
      {key === "visa" && (
        <text
          x="24"
          y="21"
          textAnchor="middle"
          className="fill-[#1a1f71] dark:fill-[#9aa6e8]"
          fontSize="12"
          fontWeight="700"
          fontStyle="italic"
          fontFamily="system-ui, sans-serif"
        >
          VISA
        </text>
      )}
      {key === "mastercard" && (
        <>
          <circle cx="20" cy="16" r="8" fill="#eb001b" />
          <circle cx="28" cy="16" r="8" fill="#f79e1b" fillOpacity="0.9" />
        </>
      )}
      {key === "amex" && (
        <>
          <rect x="6" y="7" width="36" height="18" rx="2" fill="#2e77bc" />
          <text
            x="24"
            y="19"
            textAnchor="middle"
            fill="#ffffff"
            fontSize="8"
            fontWeight="700"
            fontFamily="system-ui, sans-serif"
          >
            AMEX
          </text>
        </>
      )}
      {key === "diners" && (
        <>
          <circle cx="24" cy="16" r="9" fill="#0079be" />
          <circle cx="24" cy="16" r="4" className="fill-white" />
        </>
      )}
    </svg>
  );
}
